// Import plugin.
import React from 'react';
import ReactDOM from 'react-dom';
import IScroll from "iscroll";

class Nav extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      navList: {
        "とらのあな通販": "https://ec.toranoana.shop/tora/ec/cot/",
        "JOSHIBU通販": "https://ec.toranoana.shop/joshi/ec/",
        "アクアプラス通販": "https://ec.toranoana.shop/aqua/ec/",
        "とらのあな電子書籍": "https://ec.toranoana.shop/tora_d/digi/",
        "JOSHIBU電子書籍": "https://ec.toranoana.shop/joshi_d/digi/"
      }
    };
  }
  
  componentDidMount(){
    // Define iscroll.
    const SCROLLER = document.getElementById("navList");
    SCROLLER.addEventListener("touchmove", (e) => {
      e.preventDefault();
    }, {passive: false});
    const HEADER_SCROLLER = new IScroll(SCROLLER, {
      scrollX: true,
      scrollY: false,
      mouseWheel: true
    });
  }
  
  render(){
    return(
      <header id="navList">
        <ul>
          {
            Object.keys(this.state.navList).map((e, x) => {
              if(this.state.jsonData !== null){
                return <li key={ x }><a href={ this.state.navList[e] } target="_blank">{ e }</a></li>
              }
            })
          }
        </ul>
      </header>
    );
  }
}

export default Nav;